/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { isBadExtraction } from './is-bad-extraction';

export const baseChallengeBodyObjectSchema = z.object({
  slug: z.string().min(1).optional(),
  type: z.string().min(1),
  language: z.string().min(1).optional(),
  title: z.string().min(1),
  partOfSpeech: z.string().min(1),
  definition: z.string().min(1),
  cefrLevel: z.string().min(1),
  register: z.string().min(1),
  examples: z.string().min(1),
  commonMistakes: z.string().optional(),
  variants: z.string().nullable().optional(),
  ipaUk: z.string().nullable().optional(),
  ipaUs: z.string().nullable().optional(),
  frequencyRank: z.number().nullable().optional(),
  frequencyBand: z.string().nullable().optional(),
  difficulty: z.number().int().min(1).max(10).nullable().optional(),
  definitionSimple: z.string().nullable().optional(),
  grammarPattern: z.string().nullable().optional(),
  usageNotes: z.string().nullable().optional(),
  collocations: z.string().nullable().optional(),
  synonyms: z.string().nullable().optional(),
  antonyms: z.string().nullable().optional(),
  mnemonicHint: z.string().nullable().optional(),
  chunkType: z.string().nullable().optional(),
  literalMeaning: z.string().nullable().optional(),
  variableSlots: z.string().nullable().optional(),
  regionalVariation: z.string().nullable().optional(),
  additionalSenses: z.string().nullable().optional(),
  wordFamily: z.string().nullable().optional(),
  etymology: z.string().nullable().optional(),
  ox3000: z.number().optional(),
  ox5000: z.number().optional(),
  academic: z.number().optional(),
  titleAudioUrl: z.string().nullable().optional(),
  definitionAudioUrl: z.string().nullable().optional(),
  usageNotesAudioUrl: z.string().nullable().optional(),
  imageUrl: z.string().nullable().optional(),
  imagePrompt: z.string().nullable().optional(),
  generationModel: z.string().nullable().optional(),
  generationPromptVersion: z.string().nullable().optional(),
  generatedAt: z.string().nullable().optional(),
  confidenceScore: z.number().int().min(1).max(10).nullable().optional(),
  qualityScore: z.number().int().min(1).max(10).nullable().optional(),
  suggestedForm: z.string().nullable().optional(),
  qualityReasoning: z.string().nullable().optional(),
  triageStatus: z.string().optional(),
  published: z.number().optional(),
  errorReports: z.number().optional(),
});

export function titleQualityRefine(
  data: { title?: string; type?: string },
  ctx: z.RefinementCtx,
): void {
  if (data.title && data.type) {
    const reason = isBadExtraction(data.title, data.type);
    if (reason) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['title'],
        message: reason,
      });
    }
  }
}

export const baseChallengeBodySchema =
  baseChallengeBodyObjectSchema.superRefine(titleQualityRefine);

export type IBaseChallengeBody = z.infer<typeof baseChallengeBodySchema>;
